import { useState } from "react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo-new.png";
import { useThrottledScroll } from "@/hooks/useThrottledScroll";

const StickyHeader = () => {
  const [isVisible, setIsVisible] = useState(false);

  useThrottledScroll((scroll) => {
    setIsVisible(scroll > 300);
  });

  const handleCTAClick = () => {
    window.open("https://payhip.com/b/NWTP2", "_blank");
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="bg-card/95 backdrop-blur-md border-b border-border shadow-soft">
        <div className="container mx-auto px-4 py-3 sm:py-4 flex items-center justify-between gap-3">
          <div 
            className="flex items-center gap-3 cursor-pointer" 
            onClick={scrollToTop}
            role="button"
            aria-label="Nach oben scrollen"
          >
            {/* Logo Container mit Glow */}
            <div className="relative group cursor-pointer">
              {/* Pulsierender Glow-Ring */}
              <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl scale-150 animate-pulse group-hover:bg-primary/40 group-hover:scale-[1.8] transition-all duration-500" />
              
              {/* Logo mit Hover-Effekten */}
              <img 
                src={logo} 
                alt="Love The Nature - Naturkraft Logo" 
                className="relative h-12 w-12 sm:h-14 sm:w-14 md:h-16 md:w-16 object-contain
                           transition-all duration-500 ease-out
                           group-hover:rotate-12 group-hover:scale-110 
                           group-hover:drop-shadow-[0_0_20px_rgba(34,197,94,0.6)]"
              />
            </div>
            
            {/* Text mit Gradient und Glow */}
            <span className="font-serif font-semibold text-base sm:text-lg 
                             bg-gradient-to-r from-foreground via-primary to-foreground 
                             bg-clip-text bg-[length:200%_auto] 
                             hover:text-transparent hover:animate-shimmer
                             transition-all duration-300
                             hover:drop-shadow-[0_0_10px_rgba(34,197,94,0.4)]">
              Love The Nature
            </span>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="hidden md:flex flex-col items-end">
              <span className="text-xs text-muted-foreground line-through">39,99€</span>
              <span className="text-lg font-bold text-primary">19,99€</span>
            </div>
            <Button 
              onClick={handleCTAClick}
              size="sm"
              className="bg-primary hover:bg-primary/90 text-primary-foreground text-xs sm:text-sm px-3 sm:px-4 py-2 shadow-hover hover:shadow-glow transition-all hover:scale-105"
            >
              <span className="hidden sm:inline">Jetzt sichern</span>
              <span className="sm:hidden">19,99€</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default StickyHeader;
